
      import Bottom from './bottom.vue'
      import type { App, Plugin } from 'vue'

      export const BottomPlugin: Plugin = {
        install(app: App) {
          app.component('Bottom', Bottom)
        },
      }
      export { Bottom }
      